/**
 * Connection bar rule (architecture §9.7, AGENTS.md §3.10): live / slow / down from the heartbeat history.
 * Pure, so every client (web, Android, hub, station screens) shows the same state for the same facts.
 */
export type ConnectionState = "live" | "slow" | "down";

export interface HeartbeatFacts {
  /** ms since epoch of the last successful heartbeat, or null if none yet. */
  lastOkAt: number | null;
  /** Round-trip time of the last successful heartbeat (ms). */
  lastLatencyMs: number | null;
  now: number;
}

export const SLOW_LATENCY_MS = 2000;
export const SLOW_AFTER_MS = 8000;
export const DOWN_AFTER_MS = 20000;

export function classifyConnection(f: HeartbeatFacts): ConnectionState {
  if (f.lastOkAt === null) return "down";
  const silence = f.now - f.lastOkAt;
  if (silence > DOWN_AFTER_MS) return "down";
  if (silence > SLOW_AFTER_MS || (f.lastLatencyMs ?? 0) > SLOW_LATENCY_MS) return "slow";
  return "live";
}

const PERSIAN = "۰۱۲۳۴۵۶۷۸۹";
export const faDigits = (s: string | number): string =>
  String(s).replace(/\d/g, (d) => PERSIAN[Number(d)] ?? d);

/** "۲ ثانیه پیش" style text for the bar. */
export function sinceText(lastOkAt: number | null, now: number): string {
  if (lastOkAt === null) return "بدون پاسخ";
  const s = Math.max(0, Math.round((now - lastOkAt) / 1000));
  if (s < 60) return `${faDigits(s)} ثانیه پیش`;
  return `${faDigits(Math.round(s / 60))} دقیقه پیش`;
}
